import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./DayTank.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext";
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";

import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}




function DayTank() {

    useEffect(() => {
    
      trackPageVisit("DayTank");
    
    }, []);
  
     const { toggleValve, valves} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
const {processData,  setProcessData} = useContext(ProcessContext);
const [currentBlend, setCurrentBlend] = useState(null);
     

  const DEFAULT_VALVES = {
  FCV_1501: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_1502: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("DayTank_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_1501: { ...DEFAULT_VALVES.FCV_1501, ...parsed.FCV_1501 },
      FCV_1502: { ...DEFAULT_VALVES.FCV_1502, ...parsed.FCV_1502 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("DayTank_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const [panelPos, setPanelPos] = useState({ x: 0, y: 80 });
const [dragging, setDragging] = useState(false);
const offsetRef = useRef({ x: 0, y: 0 });

const handleMouseDown = (e) => {
  setDragging(true);

  offsetRef.current = {
    x: e.clientX - panelPos.x,
    y: e.clientY - panelPos.y,
  };
};

const handleMouseMove = (e) => {
  if (!dragging) return;

  setPanelPos({
    x: e.clientX - offsetRef.current.x,
    y: e.clientY - offsetRef.current.y,
  });
};

const handleMouseUp = () => {
  setDragging(false);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [dragging]);




const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };




// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================

            const { transmitters, flowOverrides} = usePlantStore();
            const FIC_1407 = transmitters.FIC_1407 || 0;
            const FIC_1901 = transmitters.FIC_1901 || 0;
            const FIC_13011 = transmitters.FIC_13011 || 0;
            const FIC_13021 = transmitters.FIC_13021 || 0;



  const xv1501Open = !valves?.XV_1501;
  const xv1502Open = !valves?.XV_1502;
  const xv1503Open = !valves?.XV_1503;
  const xv1504Open = !valves?.XV_1504;

  const FIC_1501 = xv1501Open ? FIC_1407 + FIC_13011 + FIC_13021: 0;


/* =========================================================
   PUMP CONTEXT
========================================================= */

const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};



/* =========================================================
   VALVE DATA
========================================================= */

const FCV1501_Opening =
Number(valveData?.FCV_1501?.opening || 0) / 100;


const FCV1502_Opening =
Number(valveData?.FCV_1502?.opening || 0) / 100;



/* =========================================================
   P-1501A / B STATUS
========================================================= */

const P1501A_Running =
pumpData?.["P-1501A"]?.running ?? false;


const P1501B_Running =
pumpData?.["P-1501B"]?.running ?? false;



const P1501_Running =
P1501A_Running || P1501B_Running;



/* =========================================================
   PUMP CAPACITY
========================================================= */

const P1501_CAPACITY = 33.453;



/* =========================================================
   SUCTION XV-1502
========================================================= */

const suctionAvailable = xv1502Open;



/* =========================================================
   PUMP TOTAL AVAILABLE FLOW
========================================================= */

const PumpFlowTarget = (P1501_Running && suctionAvailable) ? P1501_CAPACITY : 0;


/* =========================================================
   FIC-1502 MAIN DISCHARGE TO V-1502
========================================================= */

const MainFlowTarget =
PumpFlowTarget * FCV1501_Opening;


/* =========================================================
   FIC_1502
========================================================= */

const FIC_1502 = flowOverrides?.FIC_1502 ? 0 : (processData?.FIC_1502 ?? 0);

useEffect(() => {

  const lastUpdate =
    Number(
      localStorage.getItem(
        "FIC_1502_LastUpdate"
      )
    ) || Date.now();

  const elapsedSeconds =
    (Date.now() - lastUpdate) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    const current =
      Number(prev.FIC_1502 || 0);

    const systemActive =
      P1501A_Running ||
      P1501B_Running;

    const target =
      systemActive
        ? MainFlowTarget
        : 0;

    /* ====================================
       MAXIMUM 100 SCANS
       ==================================== */

    const scans =
      Math.min(
        Math.floor(
          elapsedSeconds * 10
        ),
        100
      );

    const factor =
      Math.pow(
        1 - 0.12,
        scans
      );

    const next =
      target -
      (
        target - current
      ) * factor;

    return {
      ...prev,
      FIC_1502: Number(
        next.toFixed(3)
      )
    };

  });

}, [
  MainFlowTarget,
  P1501A_Running,
  P1501B_Running
]);



useEffect(() => {

  localStorage.setItem(
    "FIC_1502_LastUpdate",
    String(Date.now())
  );

}, [FIC_1502]);




useEffect(() => {

  const timer = setInterval(() => {

    setProcessData(prev => {

      const next =
        (prev.FIC_1502 || 0) +
        (
          MainFlowTarget -
          (prev.FIC_1502 || 0)
        ) * 0.12;

      return {
        ...prev,
        FIC_1502: Number(
          next.toFixed(3)
        )
      };

    });

  }, 500);

  return () =>
    clearInterval(timer);

}, [
  MainFlowTarget,
  setProcessData
]);



/* =========================================================
   MINIMUM FLOW RECYCLE
   FCV-1502 TO V-1501
========================================================= */

const MinimumFlowTarget =
  PumpFlowTarget *
  FCV1502_Opening;

const FIC_1503 = processData?.FIC_1503 ?? 0;


useEffect(() => {

  const lastUpdate =
    Number(
      localStorage.getItem(
        "FIC_1503_LastUpdate"
      )
    ) || Date.now();

  const elapsedSeconds =
    (Date.now() - lastUpdate) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    const current =
      Number(prev.FIC_1503 || 0);


    const systemActive =
      P1501A_Running ||
      P1501B_Running;

    const target =
      systemActive
        ? MinimumFlowTarget
        : 0;

    /* ====================================
       MAXIMUM 100 SCANS
       ==================================== */

    const scans =
      Math.min(
        Math.floor(
          elapsedSeconds * 10
        ),
        100
      );

    const factor =
      Math.pow(
        1 - 0.12,
        scans
      );

    const next =
      target -
      (
        target - current
      ) * factor;

    return {
      ...prev,
      FIC_1503: Number(
        next.toFixed(3)
      )
    };

  });

}, [
  MinimumFlowTarget,
  P1501A_Running,
  P1501B_Running
]);



useEffect(() => {

  localStorage.setItem(
    "FIC_1503_LastUpdate",
    String(Date.now())
  );

}, [FIC_1503]);





/* ==========================================
READ CRUDE FROM V-1501
========================================== */

useEffect(() => {

    const interval = setInterval(() => {

        const storedCrude =
          localStorage.getItem("V1501_CRUDE");

        if (!storedCrude) return;

        setCurrentBlend(JSON.parse(storedCrude));

    }, 500);

    return () => clearInterval(interval);

}, []);


/* ==========================================
STORE CRUDE NOW INSIDE V-1502
========================================== */

useEffect(() => {

    if (!currentBlend) return;

    console.log("Writing V1502_CRUDE", currentBlend);

    localStorage.setItem(
        "V1502_CRUDE",
        JSON.stringify(currentBlend)
    );

}, [currentBlend]);


/* ==========================================
CURRENT REFINERY CRUDE
========================================== */

const refineryCrude =
    JSON.parse(
        localStorage.getItem("V1502_CRUDE")
    ) || {};


console.log(
    "V1501_CRUDE =",
    JSON.parse(localStorage.getItem("V1501_CRUDE"))
);

console.log(
    "ACTIVE_BLEND =",
    JSON.parse(localStorage.getItem("ACTIVE_BLEND"))
);

console.log(
    "V1502_CRUDE =",
    JSON.parse(localStorage.getItem("V1502_CRUDE"))
);

useEffect(() => {

  const timer = setInterval(() => {

    setProcessData(prev => {

      const next =
        (prev.FIC_1503 || 0) +
        (
          MinimumFlowTarget -
          (prev.FIC_1503 || 0)
        ) * 0.12;

      return {
        ...prev,
        FIC_1503: Number(
          next.toFixed(3)
        )
      };

    });

  }, 500);

  return () =>
    clearInterval(timer);

}, [
  MinimumFlowTarget,
  setProcessData
]);


/* =========================================================
   PT-1501 DISCHARGE PRESSURE
========================================================= */
const PT_1501 = (P1501_Running && suctionAvailable) ? (0.03 + (1.8 - 0.03) * FCV1501_Opening) : 0.03;

/* =========================================================
   TT-1501 DISCHARGE TEMPERATURE
========================================================= */
const TT_1501 = P1501_Running ? 37 : 25;



  const FIC_1504 = xv1503Open ? FIC_1502 : 0;
 const FIC_1505 = flowOverrides?.FIC_1505 ? 0 : (xv1504Open ? FIC_1901 : 0);
 
 const FIC_1506 = xv1504Open ? 1 : 0;

useEffect(() => {
  setProcessData(prev => ({
    ...prev,
    FIC_1506
  }));

}, [FIC_1506]);




  
useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.FIC_1506 === FIC_1506 && 
    current.FIC_1505 === FIC_1505 
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      FIC_1506, FIC_1505
    }
  });

}, [FIC_1506, FIC_1505]);







  return (
    <div className="DayTank-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "240px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 373px",
          zIndex: 10,
        }}
      >
        DAY TANKS
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-1501 */}
      <Valve
        className="XV-1501"
        tag="XV_1501"
        x={281}
        y={258}
        isClosed={valves.XV_1501}
        toggle={toggleValve}
      />

      {/* XV-1502 */}
      <Valve
        className="XV-1502"
        tag="XV_1502"
        x={501}
        y={388}
        isClosed={valves.XV_1502}
        toggle={toggleValve}
      />

      {/* XV-1503 */}
      <Valve
        className="XV-1503"
        tag="XV_1503"
        x={769}
        y={329}
        isClosed={valves.XV_1503}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-1504 */}
      <Valve
        className="XV-1504"
        tag="XV_1504"
        x={1087}
        y={379}
        isClosed={valves.XV_1504}
        toggle={toggleValve}
        r={90}
      />

      



      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-1501 */}
        <div
            style={{ position: "absolute", left: 860, top: 547}}
            onMouseEnter={() => setHoveredValve("FCV_1501")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_1501")}
          >

            {hoveredValve === "FCV_1501" && (
              <div style={tagStyle}>
                FCV_1501
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-1501">
                    
          <defs>
            <linearGradient id="metal_1501">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_1501)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_1501)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-1502 */}
        <div
            style={{ position: "absolute", left: 760, top: 412}}
            onMouseEnter={() => setHoveredValve("FCV_1502")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_1502")}
          >

            {hoveredValve === "FCV_1502" && (
              <div style={tagStyle}>
                FCV_1502
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-1502">
                    
          <defs>
            <linearGradient id="metal_1502">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_1502)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_1502)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>


        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}




      {/* ================= CONTROL VALVE OUTPUTS ================= */}


      <ValveOutput
        value={Number(valveData?.FCV_1501?.opening || 0)}
        x={882}
        y={592}
      />


      <ValveOutput
        value={Number(valveData?.FCV_1502?.opening || 0)}
        x={782}
        y={456}
      />


        <Transmitter
          tag="FIC_1501"
          value={[FIC_1501]}
          x={145}
          y={187}
          unit="BPM"
          max={17}
          HH={16}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE FROM CRUDE BLENDING TRANSFER PUMPS (P-1401A/B) AND/OR CRUDE TRANSFER PUMPS P-1301A/B AND P-1303A/B TO DAY TANK"
         />

         <Transmitter
          tag="FIC_1502"
          value={[FIC_1502]}
          x={910}
          y={370}
          unit="BPM"
          max={17}
          HH={16}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF OIL TRANSFER FROM P-1501A/B TO V-1502"
         />

         <Transmitter
          tag="FIC_1503"
          value={[FIC_1503]}
          x={675}
          y={452}
          unit="BPM"
          max={17}
          HH={16}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF MINIMUM FLOW BYEPASS LINE FROM P-1501A/B TO V-1501"
         />

         <Transmitter
          tag="TT_1501"
          value={[TT_1501]}
          x={755}
          y={589}
          unit="°C"
          max={70}
          HH={56}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF OIL TRANSFER FROM P-1501A/B TO V-1502"
         />

        <Transmitter
          tag="PT_1501"
          value={[PT_1501]}
          x={615}
          y={555}
          unit="MPa"
          max={3}
          HH={2.5}
          H={1.8}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF OIL TRANSFER FROM P-1501A/B TO V-1502"
         />




         
    <LevelTransmitterIndicator
      tag="LT_1501"
      totalLevel={70000}
      inflows={[FIC_1501 + FIC_1503]}
      outflows={[FIC_1502]}
      inflowTags={["FIC_1501", "FIC_1503"]}
      outflowTags={["FIC_1502"]}
      responseFactor={0.05}
      columnX={579}
      columnY={139}
      columnWidth={30}
      columnHeight={172}
      textX={620}
      textY={140}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.9}
      service="crude"
    />

    <LevelTransmitterIndicator
      tag="LT_1501"
      totalLevel={70000}
      inflows={[FIC_1501 + FIC_1503]}
      outflows={[FIC_1502]}
      inflowTags={["FIC_1501", "FIC_1503"]}
      outflowTags={["FIC_1502"]}
      responseFactor={0.05}
      columnX={420}
      columnY={139}
      columnWidth={189}
      columnHeight={172}
      textX={620}
      textY={140}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.1}
      service="crude"
    />

    <LevelTransmitterIndicator
      tag="LT_1402"
      totalLevel={70000}
      inflows={[FIC_1504]}
      outflows={[FIC_1505]}
      inflowTags={["FIC_1504"]}
      outflowTags={["FIC_1505"]}
      responseFactor={0.05}
      columnX={996}
      columnY={139}
      columnWidth={30}
      columnHeight={173}
      textX={1046}
      textY={140}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.9}
      service="crude"
    />

    <LevelTransmitterIndicator
      tag="LT_1402"
      totalLevel={70000}
      inflows={[FIC_1504]}
      outflows={[FIC_1505]}
      inflowTags={["FIC_1504"]}
      outflowTags={["FIC_1505"]}
      responseFactor={0.05}
      columnX={842}
      columnY={139}
      columnWidth={186}
      columnHeight={172}
      textX={1046}
      textY={140}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.1}
      service="crude"
    />







          <Pump
              tag="P-1501A"
              x={527}
              y={514}
              rpm={1800}
              bladeCount={pumpData?.["P-1501A"]?.bladeCount || 3}
              size={pumpData?.["P-1501A"]?.size || 43}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-1501B"
              x={526}
              y={617}
              rpm={1800}
              bladeCount={pumpData?.["P-1501B"]?.bladeCount || 3}
              size={pumpData?.["P-1501B"]?.size || 43}
              onClick={openPumpPanel}
            />








    </div>
  );
}

export default DayTank;